"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsType = void 0;
var AnalyticsType;
(function (AnalyticsType) {
    AnalyticsType["VIEWED"] = "VIEWED";
    AnalyticsType["CLICKED"] = "CLICKED";
    AnalyticsType["REDIRECT"] = "REDIRECT";
})(AnalyticsType = exports.AnalyticsType || (exports.AnalyticsType = {}));
